let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("BtsK2")).then(() => parcelRequire('7b8i9'));